<template>
  <div class="art-gallery">
    <div class="gallery-video">
      <van-swipe :autoplay="3000" indicator-color="white" @change="onChange">
        <van-swipe-item :key="index + 1" v-for="(item, index) in galleryCoverList">
          <img style="pointer-events:none;" class="swipe-img" :src="item+'?x-oss-process=image/resize,l_682'" alt=""/>
        </van-swipe-item>
        <div class="custom-indicator" slot="indicator">
          <template v-for="(item, index) in galleryCoverList" >
            <div :key="index + 1" class="custom-indicator-item" :class="current == index ? 'custom-indicator-active' : ''"></div>
          </template>
        </div>
      </van-swipe>
    </div>
    <div class="gallery-btn" @click="openGallery">
      <van-image style="pointer-events:none;" :src="require('@/assets/artTitle.png')" width="100%" height="100%"></van-image>
      <div style="pointer-events:none;" class="gallery-desc">
        {{ galleryName }}
      </div>
    </div>
    <story-main :needExpend="false" :description="galleryDesc"></story-main>
  </div>
</template>
<script>
import storyMain from '../storyMain/storyMain.vue'
import { Swipe, SwipeItem } from 'vant'
export default {
  components: {
    storyMain,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  props: {
    galleryCoverList: {
      type: Array
    },
    galleryName: {
      type: String,
      default: ''
    },
    galleryDesc: {
      type: String,
      default: ''
    },
    galleryId: {
      type: String,
      default: '5'
    }
  },
  data () {
    return {
      isShow: true,
      current: 0
    }
  },
  computed: {
    isFont () {
      if (this.artItme.galleryDesc.length > 20) {
        return true
      }
      return false
    }
  },
  methods: {
    onChange (index) {
      this.current = index
    },
    // 打开云展厅方法
    openGallery () {
      // this.$router.push({
      //   name: 'unilty',
      //   query: {
      //     galleryId: this.galleryId
      //   }
      // })
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.art-gallery {
  background: #fff;
  .gallery-title {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333333;
    padding: 0 17px 20px;
  }
  .story {
    padding: 20px 17px;
    background: linear-gradient(0deg, #FFFFFF, #FFFFFF, #F4EBE1);

  }
  .gallery-video {
    width: 341px;
    height: 250px;
    > video {
      width: 100%;
      height: 100%;
    }
    .swipe-img {
      width: 341px;
      height: 250px;
    }
  }
  .gallery-comment {
    display: flex;

    .comment {
      flex: 1;
      background: #f2f2f2;
      border-radius: 36px;
      padding: 11px 10px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #727272;
    }
    .control {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 15px;
      > div {
        width: 24px;
        height: 24px;
        margin-right: 30px;
      }
      .share {
        width: 32px;
        height: 32px;
        margin-right: 0;
      }
    }
  }
  .gallery-btn {
    height: 48px;
    line-height: 40px;
    text-align: center;
    font-family: SourceHanSerifCN-SemiBold;
    border-radius: 2px;
    margin-top: 12px;
    position: relative;
    >div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }

    .gallery-desc {
      width: 100%;
      text-align: left;
      padding-left: 100px;
      font-size: 16px;
      color: #A26F43;
      font-weight: bold;
    }
  }
}
.custom-indicator {
  display: flex;
  position: absolute;
  left: 50%;
  bottom: 10px;
  text-align: center;
  white-space: nowrap;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.custom-indicator-item {
  width: 6px;
  height: 2px;
  border-radius: 2px;
  margin-right: 8px;
  background-color: rgba(255, 255, 255, 0.3);
}
.custom-indicator-active {
  width: 10px !important;
  background-color: #fff !important;
}
</style>
